import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { CURRENT_DATE } from '../../constants';
import '../../css/modal.css';
import { useParams } from 'react-router-dom';

const PortalForm = () => {
  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);
  const [message, setMessage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState([]);

  const { route } = useParams();

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform2/${route}`;
    console.log('url:', url);
    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(`${API_URL}/api/users/get-company`);

        console.log(response.data.company);
        setCompany(response.data.company[0]);
        const company = response.data.company[0];

        if (company?.name) {
          document.title = company.name;
        }

        // Set Favicon
        if (company?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) {
            favicon.href = company.logo; // Update favicon dynamically
          }
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        setMessage('Company not found');
      }
    };

    const fetchForm = async () => {
      const initialState = {};
      try {
        const response = await axios.get(url, {
          headers: {
            // 'Authorization': token ? `Bearer ${token}` : '',
          },
        });
        setLink(response.data.link);
        console.log('link:', response.data.link);
        setInputs(response.data.inputs);
        //Loop through form inputs and create initial key values form inputs
        response.data.inputs.map((input) => {
          if (input.type === 'file') {
            initialState[input.name] = null;
          } else if (input.type === 'hidden-user') {
            initialState[input.name] = 0;
          } else if (input.type === 'date' || input.name === 'date') {
            initialState[input.name] = CURRENT_DATE;
          } else {
            initialState[input.name] = input.value ? input.value.trim() : '';
          }
        });

        //add default values for user_id and date
        // initialState['user_id'] = null;
        // initialState['date'] = CURRENT_DATE;
        //Set all initial input values to the state values
        setValues(initialState);

        setLoading(false);
        // document.title = response.data.link.page_title; // Update title dynamically
      } catch (error) {
        console.error('Error fetching data:', error);
        setLink([]);
        setInputs([]);
        setLoading(false);
      }
    };

    fetchCompany();

    fetchForm();
  }, [route]);

  console.log('link:', link);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    //console.log(name, value, type, checked );
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // Handle file input changes dynamically
  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0]; // Get the selected file

    setValues((prev) => ({
      ...prev,
      [name]: file, // Dynamically set the file input field by name
    }));
  };

  //console.log('insert route:', `${API_URL}/${ENDPOINTS.SYS}/create/${route}`)

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      //  const route2 = route.replace(/^\s+|\s+$/g, ""); // Trims leading and trailing spaces
      //console.log('route: "' , route,'", route2: "', route2,'"');
      var insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create2/${route}`;
      if (link.sql_query && link.sql_query.trim() !== '') {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/createCustom2/${route}`;
      } else if (
        link.api_route &&
        link.api_route !== '' &&
        link.api_route.trim() !== ''
      ) {
        insertUrl = `${API_URL}/${link.api_route}`;
        link.form_type = 'reg-upload-modal'; // to send to upload for test only
      } else if (link.form_type === 'reg-upload-modal') {
        insertUrl = `${API_URL}/${ENDPOINTS.SYS}/create-upload2/${route}`;
      }
      console.log('insert route:', insertUrl, 'values:', values);

      const data = new FormData();

      // Append all fields (including files) to FormData
      Object.keys(values).forEach((key) => {
        data.append(key, values[key]); // Appends both files and text fields dynamically
      });
      try {
        var response;
        if (link.form_type === 'reg-upload-modal') {
          console.log('data:', data.entries());

          response = await axios.post(insertUrl, data, {
            headers: {
              'Content-Type': 'multipart/form-data', // Required for FormData
              // 'Authorization': token ? `Bearer ${token}` : '',
            },
          });
        } else {
          response = await axios.post(insertUrl, values, {
            headers: {
              // 'Authorization': token ? `Bearer ${token}` : '',
            },
          });
        }

        setMessage(response.data);

        // onRequestClose(); // Close modal after submission
      } catch (error) {
        alert(`An error occurred ${error.message}`);
        // console.log('error:', error, 'insertUrl:',insertUrl, 'values:', values);
      }
    } catch (error) {
      alert(`An error occurred ${error.message}`);
    }
  };

  return (
    <div
      className="container-fluid min-vh-100 d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: `url(${API_URL}/${company.background_image})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="col-md-4 p-4 border rounded shadow-lg bg-light">
        {/* Company Logo */}
        <div className="text-center mb-4">
          {company.logo && (
            <img
              src={`${API_URL}/${company.logo}`}
              alt="Company Logo"
              style={{
                maxWidth: '100%',
                maxHeight: '100px',
                objectFit: 'contain',
              }}
            />
          )}
        </div>

        <h2 className="text-center mb-4">{company.name}</h2>
        <h2 className="text-center mb-4">{link?.page_title}</h2>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          {inputs &&
            inputs.map((input) => {
              const options =
                input.options?.split(',').map((option) => option.trim()) || [];

              return (
                <div className="mb-3" key={input.name}>
                  {input.type !== 'hidden-user' && input.type !== 'hidden' && (
                    <>
                      <label
                        htmlFor={input.name}
                        className="form-label text-capitalize font-weight-bold"
                      >
                        {input.label}:{' '}
                        {input.is_required && (
                          <span
                            className="text-danger"
                            title={`'${input.label}' field is required, please fill it before submit the form`}
                          >
                            {' '}
                            *
                          </span>
                        )}
                      </label>{' '}
                      &nbsp;&nbsp;
                    </>
                  )}
                  {(() => {
                    switch (input.type) {
                      case 'radio':
                        return (
                          input.dynamic_options &&
                          input.dynamic_options.map((option, index) => (
                            <div
                              className="form-check form-check-inline"
                              key={index}
                            >
                              <input
                                type="radio"
                                className="form-check-input"
                                id={`${input.name}-${index}`}
                                name={input.name}
                                value={option.id}
                                checked={values[input.name] === option.id}
                                onChange={handleChange}
                              />
                              <label
                                htmlFor={`${input.name}-${index}`}
                                className="form-check-label"
                              >
                                {option.name}
                              </label>
                            </div>
                          ))
                        );

                      case 'dropdown':
                        return (
                          <select
                            className="form-select"
                            id={input.name}
                            name={input.name}
                            value={values[input.name]}
                            onChange={handleChange}
                            required={input.is_required}
                          >
                            <option value="" disabled>
                              Select an option
                            </option>
                            {input.dynamic_options &&
                              input.dynamic_options.map((option, index) => (
                                <option key={index} value={option.id}>
                                  {option.name}
                                </option>
                              ))}
                          </select>
                        );
                      case 'enum':
                        return (
                          options &&
                          options.map((option, index) => (
                            <div
                              className="form-check form-check-inline"
                              key={index}
                            >
                              <input
                                type="radio"
                                className="form-check-input"
                                id={`${input.name}-${index}`}
                                name={input.name}
                                value={option}
                                checked={values[input.name] === option}
                                onChange={handleChange}
                              />
                              <label
                                htmlFor={`${input.name}-${index}`}
                                className="form-check-label"
                              >
                                {option}
                              </label>
                            </div>
                          ))
                        );
                      case 'enum-dropdown':
                        return (
                          <select
                            className="form-select"
                            id={input.name}
                            name={input.name}
                            value={values[input.name]}
                            onChange={handleChange}
                            required={input.is_required}
                          >
                            <option value="" disabled>
                              Select an option
                            </option>
                            {options &&
                              options.map((option, index) => (
                                <option key={index} value={option}>
                                  {option}
                                </option>
                              ))}
                          </select>
                        );

                      case 'checkbox':
                        return (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={input.name}
                              name={input.name}
                              value={values[input.name]}
                              checked={values[input.name]}
                              onChange={handleChange}
                            />
                            <label
                              htmlFor={input.name}
                              className="form-check-label"
                            >
                              {input.label}
                            </label>
                          </div>
                        );

                      case 'hidden-user':
                        return (
                          <input
                            type="hidden"
                            id={input.name}
                            name={input.name}
                            value="0"
                            required={input.is_required}
                          />
                        );
                      case 'textarea':
                        return (
                          <textarea
                            className="form-control"
                            id={input.name}
                            name={input.name}
                            rows="3"
                            value={values[input.name]}
                            onChange={handleChange}
                            required={input.is_required}
                          ></textarea>
                        );
                      case 'file':
                        return (
                          <>
                            <input
                              title="file"
                              type={input.type}
                              className="form-control"
                              id={input.name}
                              name={input.name}
                              placeholder={input.placeholder}
                              onChange={handleFileChange}
                              required={input.is_required}
                              accept={input.allowed_extensions} // Restricts file type selection in the browser
                            />
                            <p className="text-danger">
                              Only allowed files: '{input.allowed_extensions}',
                              Max size: {input.max_size_mb}MB
                            </p>
                          </>
                        );
                      default:
                        return (
                          <input
                            type={input.type}
                            className="form-control"
                            id={input.name}
                            name={input.name}
                            placeholder={input.placeholder}
                            value={values[input.name]}
                            onChange={handleChange}
                            required={input.is_required}
                          />
                        );
                    }
                  })()}
                </div>
              );
            })}

          <button type="submit" className="btn btn-primary">
            Submit
          </button>

          {message.success === 0 && (
            <div className="alert alert-danger" role="alert">
              {message.message}
            </div>
          )}
          {message.success === 1 && (
            <div className="alert alert-success" role="alert">
              {message.message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default PortalForm;
